export const DEFAULT_TITLE = "App Center";
export const TAG_LINE = "Fresh, fast, and fun mission control for any app.";
